import callBC from "../../helpers/bc";
import { tokenDictionary } from "../../../config";
const { last } = require("ramda");

const getHeight = async (settings, height) => {
  let block = window.getStorage(`bc.height.${height}`);
  if (block) return block;
  let data = await callBC(settings, "getBlockHeight", [height]);
  window.setStorage(`bc.height.${height}`, JSON.stringify(data.result));
  return data.result;
};

export const unlockData = async (
  settings,
  latestBlock,
  {
    tradeHeight,
    settlement,
    shiftMaker,
    shiftTaker,
    sendsFromChain,
    receivesToChain,
  }
) => {
  try {
    let bcLeft = tradeHeight + settlement - latestBlock.height;
    if (bcLeft > 0) {
      let unlockText = `in ${bcLeft} BC Blocks`;

      if (tokenDictionary[sendsFromChain].toUpperCase() !== "BC") {
        unlockText += ` + ${shiftMaker + 1} ${tokenDictionary[
          sendsFromChain
        ].toUpperCase()} Blocks`;
      }

      if (
        tokenDictionary[sendsFromChain].toUpperCase() !=
        tokenDictionary[receivesToChain].toUpperCase()
      ) {
        unlockText += ` + ${shiftTaker + 1} ${tokenDictionary[
          receivesToChain
        ].toUpperCase()} Blocks`;
      }
      return {
        bcLeft,
        unlockText,
      };
    } else {
      let data = await getHeight(settings, tradeHeight + settlement);
      if (data && data.hash) {
        let settleBlock = data;
        let lastestChildMaker = last(getChild(latestBlock, sendsFromChain))
          .height;
        let lastestChildTaker = last(getChild(latestBlock, receivesToChain))
          .height;
        let settleChildMaker = last(getChild(settleBlock, sendsFromChain))
          .height;
        let settleChildTaker = last(getChild(settleBlock, receivesToChain))
          .height;

        let takerLeft = settleChildTaker + shiftTaker + 1 - lastestChildTaker;
        let makerLeft = settleChildMaker + shiftMaker + 1 - lastestChildMaker;

        let unlockText = "";
        if (
          tokenDictionary[sendsFromChain].toUpperCase() !== "BC" &&
          makerLeft > 0
        ) {
          unlockText += `in ${makerLeft} ${tokenDictionary[
            sendsFromChain
          ].toUpperCase()} Blocks`;
        }

        if (
          tokenDictionary[sendsFromChain].toUpperCase() !=
            tokenDictionary[receivesToChain].toUpperCase() &&
          takerLeft > 0
        ) {
          if (unlockText.length > 0) unlockText += " + ";
          else unlockText = "in ";
          unlockText += ` ${takerLeft} ${tokenDictionary[
            receivesToChain
          ].toUpperCase()} Blocks`;
        }

        return {
          unlockText,
          bcLeft: 0,
          takerLeft,
          makerLeft,
        };
      } else {
        return {};
      }
    }
  } catch (err) {
    console.log({ err });
    return false;
  }
};

function getChild(block, child) {
  if (child.toLowerCase() === "nrg") {
    return [block];
  } else {
    let childChain = tokenDictionary[child];
    return block.blockchainHeaders[`${childChain}List`];
  }
}
